export default __webpack_public_path__ + "images/33_2_image.jpg";